<template>
  <div class="parse-rule">
    <a-form-model :model="ruleForm">
      <a-form-model-item label="匹配路径">
        <div class="rule-wrap">
          <div class="rule-item" v-for="(item, index) in ruleForm.urls" :key="index">
            <div class="input">
              <a-input v-model="ruleForm.urls[index]" placeholder="请输入匹配路径" />
            </div>
            <div class="operate" >
              <a-tooltip>
                <template slot="title">复制</template>
                <a-icon type="copy" @click="handleCopySite(item, index)" />
              </a-tooltip>

              <a-tooltip>
                <template slot="title">新增</template>
                <a-icon type="plus-circle" @click="handleAddSite(index)" />
              </a-tooltip>

              <a-tooltip>
                <template slot="title">删除</template>
                <a-icon type="minus-circle" v-if="index > 0" @click="handleDeleteSite(index)" />
              </a-tooltip>
            </div>
          </div>
        </div>
      </a-form-model-item>
      <a-form-model-item label="字段解析">
        <div class="rule-wrap">
          <div class="rule-item" v-for="(item, index) in ruleForm.spiderConfigs" :key="index">
            <div class="filed">
              <a-input v-model="item.name" placeholder="请输入字段名称" />
            </div>
            <div class="input">
              <a-input v-model="item.rule" placeholder="请输入选择器" />
            </div>
            <div class="operate" >
              <a-tooltip>
                <template slot="title">复制</template>
                <a-icon type="copy" @click="handleCopyRule(item, index)" />
              </a-tooltip>
              <a-tooltip>
                <template slot="title">新增</template>
                <a-icon type="plus-circle" @click="handleAddRule(index)" />
              </a-tooltip>
              <a-tooltip>
                <template slot="title">删除</template>
                <a-icon type="minus-circle" v-if="index > 0" @click="handleDeleteRule(index)" />
              </a-tooltip>
            </div>
          </div>
        </div>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  data() {
    return {}
  },
  props: ['ruleForm'],
  methods: {
    handleCopySite(val, index) {
      this.ruleForm.urls.splice(index, 0, _.cloneDeep(val))
    },
    handleAddSite(index) {
      this.ruleForm.urls.splice(index + 1, 0, '')
    },
    handleDeleteSite(index) {
      this.ruleForm.urls.splice(index, 1)
    },
    handleCopyRule(val, index) {
      this.ruleForm.spiderConfigs.splice(index, 0, _.cloneDeep(val))
    },
    handleAddRule(index) {
      this.ruleForm.spiderConfigs.splice(index + 1, 0, { filed: '', rule: '' })
    },
    handleDeleteRule(index) {
      this.ruleForm.spiderConfigs.splice(index, 1)
    }
  }
}
</script>

<style lang="less" scoped>
.parse-rule {
  padding: 1px 8px 0px;
  .rule-item {
    display: flex;
    .operate {
      margin-left: 15px;
      width: 80px;
      text-align: right;
      i {
        margin-right: 10px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        color: #1890ff;
      }
    }
    .filed {
      margin-right: 10px;
      width: 120px;
    }
    .input {
      flex: 1;
    }
  }
}
.rule-wrap {
  display: flex;
  flex-wrap: wrap;
  .rule-item {
    width: 50%;
    padding-right: 20px;
  }
}
</style>
